export default function LoadingFrame() {
	return (
		<div className="app-loader">
			<div className="spinner-border" role="status">
				<span className="visually-hidden">Loading...</span>
			</div>
		</div>
	);
}
